import { SendStockUseCase } from '@Core/Domain/UseCases'

export const Register = {
    UseCaseSendStock: SendStockUseCase,
}
